import { useTranslation } from 'react-i18next'

import { CaretDownIcon, CaretUpIcon, CircleIcon, MinusCircleIcon, PlusCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import ConceptAmountInput from './ConceptAmountInput/ConceptAmountInput'
import ConceptItemRow from './ConceptItemRow/ConceptItemRow'
import ConceptLineItem from './ConceptLineItem/ConceptLineItem'
import useConceptToggle from './useConceptToggle/useConceptToggle'
import { getHeaderAmount } from './helpers'
import * as Styles from './styles'

const ConceptToggle = ({
  label,
  selected,
  amount,
  currency,
  maxAmount,
  isNegative,
  editable,
  expandable,
  items,
  lineItems,
  error,
  hasError,
  onToggle,
  onChangeAmount,
  onChangeItemAmount,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { expanded, canExpand, toggleExpanded } = useConceptToggle({ selected, editable, expandable })

  const handleToggle = () => {
    onToggle()
  }

  const handleExpand = event => {
    event.stopPropagation()
    toggleExpanded()
  }

  const getIcon = () => {
    if (!selected) return <CircleIcon color={theme.colors.outline.default} size={26} data-testid="circleIcon" />

    if (isNegative) {
      return <MinusCircleIcon color={theme.colors.warning.onSurface} size={26} weight="fill" data-testid="plusIcon" />
    }

    return <PlusCircleIcon color={theme.colors.outline.default} size={26} weight="fill" data-testid="plusIcon" />
  }

  const getCaretIcon = () => {
    if (expanded) return <CaretUpIcon size={20} data-testid="showProducts" />

    return <CaretDownIcon size={20} data-testid="showProducts" />
  }

  return (
    <Styles.Container selected={selected} isNegative={isNegative}>
      <Styles.HeaderContainer onClick={handleToggle}>
        <Styles.LabelContainer>
          {getIcon()}
          <Text tag="label" type="bodyMBold">
            {label}
          </Text>
          {canExpand && (
            <Styles.ExpandButton type="button" onClick={handleExpand} aria-label={t('Desglose')}>
              {getCaretIcon()}
            </Styles.ExpandButton>
          )}
        </Styles.LabelContainer>
        <Styles.AmountContainer hasError={hasError}>
          <Text type={selected ? 'bodyMBold' : 'bodyMRegular'}>
            <FormatPrice currency={currency}>{getHeaderAmount({ amount, isNegative })}</FormatPrice>
          </Text>
        </Styles.AmountContainer>
      </Styles.HeaderContainer>
      {expanded && (
        <Styles.BodyContainer>
          {items?.length > 0 &&
            items.map(item => (
              <ConceptItemRow
                key={item.id}
                item={item}
                currency={currency}
                isNegative={isNegative}
                disabled={!selected}
                onChangeAmount={onChangeItemAmount}
              />
            ))}
          {expandable &&
            !items?.length &&
            lineItems?.map((lineItem, index) => (
              <ConceptLineItem key={index} lineItem={lineItem} currency={currency} />
            ))}
          {editable && !items?.length && (
            <Styles.AmountRowContainer>
              <Text type="bodySRegular" color={theme.colors.text.muted}>
                {t('Importe')}
              </Text>
              <Styles.AmountInputContainer>
                <ConceptAmountInput
                  label={label}
                  value={amount}
                  currency={currency}
                  isNegative={isNegative}
                  maxAmount={maxAmount}
                  error={error}
                  disabled={!selected}
                  onChange={onChangeAmount}
                />
              </Styles.AmountInputContainer>
            </Styles.AmountRowContainer>
          )}
        </Styles.BodyContainer>
      )}
    </Styles.Container>
  )
}

export default ConceptToggle
